import React, {Fragment} from 'react'
import {connect} from 'react-redux'
import {TripListItem, RouteListItem} from 'common/ListItems'
import {Route as RouteV3, Trip as TripV3} from 'data/records'
import {Route as RouteV2, Trip as TripV2} from 'lib/api/records'
import * as favoritesActions from 'lib/api/favorites'
import * as tripsActions from 'lib/api/trips'
import * as routesActions from 'lib/api/routes'
import {DELETE_TROUTE_DIALOG, DeleteTRoute} from 'common/dialogs/DeleteTRoute'

const ROUTE = 'route'
const TRIP = 'trip'

const getType = (tr) => {
  if (tr instanceof RouteV2 || tr instanceof RouteV3) {
    return ROUTE
  }
  if (tr instanceof TripV2 || tr instanceof TripV3) {
    return TRIP
  }
}

export class TRouteItem extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      dialog: null
    }
  }

  showDialog = (dialog) => {
    this.setState({dialog})
  }

  hideDialog = () => {
    this.setState({dialog: null})
  }

  deleteConfirmed = () => {
    const {r, deleteRoute, deleteTrip, onDelete} = this.props

    let promise
    if (getType(r) === ROUTE) {
      promise = deleteRoute(r.id).payload
    } else if (getType(r) === TRIP) {
      promise = deleteTrip(r.id).payload
    }

    onDelete && onDelete(r, promise)
    return promise
  }

  deleteClicked = () => {
    this.showDialog(DELETE_TROUTE_DIALOG)
  }

  render () {
    const {r, deleteClicked, ...otherProps} = this.props
    const {dialog} = this.state

    return (
      <Fragment>
        {getType(r) === ROUTE
          ? <RouteListItem
            route={r}
            deleteClicked={deleteClicked ? () => deleteClicked(r) : () => this.deleteClicked()}
            {...otherProps} />
          : <TripListItem
            trip={r}
            deleteClicked={deleteClicked ? () => deleteClicked(r) : () => this.deleteClicked()}
            {...otherProps} />}
        {dialog === DELETE_TROUTE_DIALOG &&
          <DeleteTRoute troute={r} onRequestClose={this.hideDialog} onConfirm={this.deleteConfirmed} />}
      </Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const type = getType(ownProps.r) === ROUTE ? 'route' : 'trip'

  return {
    pin: (id) => dispatch(favoritesActions.pin(type, id)),
    unpin: (id) => dispatch(favoritesActions.unpin(type, id)),
    deleteTrip: tripsActions.deleteTrip,
    deleteRoute: routesActions.deleteRoute
  }
}

const mapStateToProps = (state, ownProps) => {
  const type = getType(ownProps.r) === ROUTE ? 'route' : 'trip'
  const favorites = state.favorites

  return {
    pinned: !!favorites.getIn(['favoritesByType', type, ownProps.r.get('id')])
  }
}

export const TRouteItemContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TRouteItem)
